import serverCall from "../../serverCall";

const createCollection = async (data) => {
  const response = await serverCall.post(`/collection/admin/create`, data);
  return response;
};

const updateCollection = async (data) => {
  const response = await serverCall.post(`/collection/admin/edit`, data);
  return response;
};

const GetAllCollection = async (pageNumber, pageSize, search) => {
  let response = "";
  if (pageNumber === 0 && pageSize === 0) {
    response = await serverCall.get(
      `/collection/admin/all?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  } else {
    response = await serverCall.get(
      `/collection/admin/all?pageNumber=${pageNumber}&pageSize=${pageSize}&searchText=${search}`
    );
  }
  return response;
};

// const GetAllImages = async (
//   pageNumber,
//   pageSize,
//   collection,
//   search,
//   imageType,
//   sortBy,
//   sortType
// ) => {
//   let response = "";
//   if (imageType !== "All") {
//     response = await serverCall.get(
//       `/images/admin/search?collectionName=${collection}&imageType=${imageType}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchTags=${search}&sortBy=${sortBy}&sortType=${sortType}`
//     );
//   } else {
//     response = await serverCall.get(
//       `/images/admin/search?collectionName=${collection}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchTags=${search}&sortBy=${sortBy}&sortType=${sortType}`
//     );
//   }
//   return response;
// };

const DeleteCollection = async (id) => {
  const response = await serverCall.delete(`/collection/admin/${id}`);
  return response;
};
const CollectionService = {
  createCollection,
  updateCollection,
  GetAllCollection,
  // GetAllImages,
  DeleteCollection,
};

export default CollectionService;
